import { Row, Col, Container, Card, CardBody, CardTitle } from "reactstrap";
import { useTranslation } from "react-i18next";
import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import Slider from "react-slick";
import {
  SETTINGS_SINGLE_ITEM,
  SETTINGS_THREE_ITEM,
} from "constants/sliderSetting";
import About from "assets/image/about.png";
import Support from "assets/image/support-person.png";
import UserGroup from "assets/image/user-group.png";
import Team from "assets/image/Team.png";
import CurrencyGroup from "assets/image/currency-group.png";
import DigitalWallet from "assets/image/digital-wallet.png";
import Afshar from "assets/image/afshar-jokar.png";
import Hosein from "assets/image/hosein-montazer.png";
import Vahid from "assets/image/vahid-vali.png";
import DevelopTeam from "assets/image/develop-team.png";

import cn from "classnames";
import SupportTeam from "assets/image/support-team.png";
import marketTeam from "assets/image/market-team.png";

import "assets/styles/components/slider.scss";
import "assets/styles/components/lists.scss";

const AboutUs = () => {
  const { t } = useTranslation();
  const settings = SETTINGS_SINGLE_ITEM;
  const boxSetting = SETTINGS_THREE_ITEM;
  const sliderItems = [
    {
      title: "Hosein Montazer",
      text: "Sells manager at Coinnik market",
      imgSrc: Hosein,
    },
    {
      title: "Afshar Joukar",
      text: "CEO at Coinnik market",
      imgSrc: Afshar,
    },
    {
      title: "Vahid Vali",
      text: "CEO at Nikandish holding",
      imgSrc: Vahid,
    },
  ];
  const sliderSingleItems = [
    { imgSrc: DevelopTeam },
    { imgSrc: SupportTeam },
    { imgSrc: About },
  ];
  return (
    <div className="about-us-parent ">
      <StaticHeaderInfo>
        <div className="title-style mb-5 mb-md-0">
          <span className="text-light fs-2 fw-bold ">
            {t("About Coinnik market")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container>
        <Row className="my-3 ">
          <Col xs="12">
            <Card className="shadow border-radius-1 mt-n5 mt-md-0">
              <CardBody>
                <Row className="py-3  flex-row-reverse ">
                  <CardTitle className="mb-4 mb-md-0">
                    <span className="title-bordre-bottom ">
                      {t("The story of the formation of Kevin Nick Market")}
                    </span>
                  </CardTitle>
                  <Col xs={{ order: 3 }} sm="12" md="12" lg="7" xl="7">
                    <p className="text-secondary-seven-light pt-4">
                      {t("About_coinnik_market")}
                    </p>
                    <Row>
                      <Col xs={12} className="text-dark">
                        <div className="divided">
                          <Line number="2020" text={t("Coinnik Market")} />
                          <span className="divider"></span>
                          <Line
                            number="2019"
                            text={t("Coinnik market platform")}
                          />
                          <span className="divider"></span>
                          <div className="text-dark d-flex flex-column justify-content-center align-items-center">
                            <Line
                              number="2018"
                              text={t("Tetrabalk platform")}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={{ order: 2 }} className="d-none d-lg-block" lg="1" />
                  <Col
                    xs={{ order: 1 }}
                    sm="12"
                    md="12"
                    lg="4"
                    xl="4"
                    className=""
                  >
                    <Slider {...settings} className="center-dot">
                      {sliderSingleItems.map((item) => (
                        <img src={item.imgSrc} />
                      ))}
                    </Slider>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="position-relative ">
          <Col xs="12">
            <Card className="shadow bg-primary-one border-radius-1 py-3">
              <CardBody>
                <Row className="flex-row-reverse ">
                  <CardTitles
                    title={t("Coinnik market Values")}
                    className="text-white"
                  />
                  <Col xs={{ order: 3 }} sm="12" md="12" lg="6" xl="6">
                    <p className="text-white  lh-xl ">
                      {t("Coinnik_market_Values")}
                    </p>
                    <ListItems
                      firstText={t(
                        "Create a secure blockchain-based exchange platform"
                      )}
                      secondText={t("Enabling fast and immediate exchanges")}
                      thirdText={t(
                        "Transparency and simplicity in using the platform"
                      )}
                    />
                  </Col>
                  <Col xs={{ order: 2 }} lg="2" className="d-none d-lg-block" />
                  <Col
                    xs={{ order: 1 }}
                    sm="12"
                    md="12"
                    lg="4"
                    xl="4"
                    className=""
                  >
                    <img src={Team} className="w-100 " />
                  </Col>
                </Row>
                <Row className="py-5">
                  <Col lg="6" xl="6" className="d-none d-lg-block">
                    <img src={marketTeam} />
                  </Col>
                  <Col
                    xs="12"
                    lg="6"
                    xl="6"
                    className="d-flex flex-column justify-content-center"
                  >
                    <CardTitles
                      title={t("Coinnik market Vision")}
                      className="text-white"
                    />
                    <p className="text-white lh-xl">
                      {t("Coinnik_market_vision")}
                    </p>
                  </Col>
                </Row>
                <Row className="pb-5 flex-row-reverse">
                  <CardTitles
                    title={t("Benefits of Coinnik market")}
                    className="text-white"
                  />
                  <Col xs={{ order: 3 }} sm="12" md="12" lg="6" xl="6">
                    <p className="text-white lh-xl ">
                      {t("Coinnik_market_Advantages")}
                    </p>
                    <ListItems
                      firstText={t(
                        "Credibility and transparency for users' peace of mind"
                      )}
                      secondText={t("Creating a safe and reliable environment")}
                      thirdText={t(
                        "Speed and simplicity in buying and selling digital currencies"
                      )}
                    />
                  </Col>
                  <Col xs={{ order: 2 }} lg="2" className="d-none d-lg-block" />
                  <Col
                    xs={{ order: 1 }}
                    sm="12"
                    md="12"
                    lg="4"
                    xl="4"
                    className=""
                  >
                    <img src={Support} className="w-100 " />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="my-5 ">
          <Col xs="12" className="">
            <div className="d-flex justify-content-center pb-5">
              <span className="title-bordre-bottom ">
                {t("Coinnik market team")}
              </span>
            </div>
            <Row>
              <Slider {...boxSetting}>
                {sliderItems.map((item) => (
                  <ContentSlider
                    title={t(item.title)}
                    text={t(item.text)}
                    imgSrc={item.imgSrc}
                  />
                ))}
              </Slider>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const ContentSlider = ({ title, text, imgSrc }: any) => (
  <Col xl="12">
    <div className="d-flex flex-column justify-content-center align-items-center ">
      <img src={imgSrc} className="border-radius-1 mb-3" />
      <span>{title}</span>
      <span className="text-secondary-one-light pt-3">{text}</span>
    </div>
  </Col>
);
const ListItems = ({ firstText, secondText, thirdText }: any) => (
  <div className="list text-secondary-eight-light">
    <ul>
      <li className="d-flex">
        <img src={DigitalWallet} />
        <span className="px-4 "> {firstText}</span>
      </li>
      <li className="py-3">
        <img src={CurrencyGroup} />
        <span className="px-4"> {secondText}</span>
      </li>
      <li>
        <img src={UserGroup} />
        <span className="px-4">{thirdText}</span>
      </li>
    </ul>
  </div>
);
const CardTitles = ({ title, className }: any) => (
  <CardTitle className="pb-4">
    <span className={cn("title-bordre-bottom fw-bold fs-5 ", className)}>
      {title}
    </span>
  </CardTitle>
);
const Line = ({ number, text }: any) => (
  <div className="text-dark d-flex flex-column justify-content-center align-items-center">
    <span className=" text-secondary-seven-light  fs-5">{number}</span>
    <span className="circle my-3"></span>
    <span className="text-secondary-seven-light fs-6">{text}</span>
  </div>
);
export default AboutUs;
